import React, { Component } from "react";
import { Grid, Panel, Col, Button } from "react-bootstrap";
import Between from "./Between.jsx";
import WhereToSearch from "./WhereToSearch.jsx";
export default class WordSearchFormRepeatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      repeatedItems: [[].concat(this.props.children)],
      showBetween: false,
      wheretosearch: "phys_lineid",
      pwrelevantnumbering: "pwrelevantnumbering",
      className: ["hide", "hide", "hide", "hide", "hide"],
    };
    this.recursiveCloneChildren = this.recursiveCloneChildren.bind(this);
    this.showhide = this.showhide.bind(this);
    this.disableAnd = this.disableAnd.bind(this);
  }

  recursiveCloneChildren(children, i) {
    return React.Children.map(children, (child) => {
      var childProps = {};
      if (React.isValidElement(child)) {
        //childProps = {id: child.props.id +'-' + (i + 1)};

        if (child.props.name) {
          if (child.props.name === "word") {
            // dette er spesielt.. vi sjekker om det er input (word) og lager ref ut ifra det slik at vi kan sette inn char on click
            let pff = (input) => {
              this["textInput" + i] = input;
            };
            childProps = {
              key: i + 1,
              inputRef: pff,
              name: child.props.name + "-" + (i + 1),
            };
          } else
            childProps = { key: i + 1, name: child.props.name + "-" + (i + 1) };
        }
        if (child.props.id) {
          childProps = { key: i + 1, id: child.props.id + "-" + (i + 1) };
        }
        if (
          child.type === "div" &&
          child.props.className === "wordsearch_showhide"
        ) {
          childProps = { className: this.state.className[i] };
        }
      }
      if (child.props) {
        childProps.children = this.recursiveCloneChildren(
          child.props.children,
          i
        );
        return React.cloneElement(child, childProps);
      }

      return child;
    });
  }

  disableAnd(e) {
    this.setState({ wheretosearch: e.target.value });
  }
  pwrelevantnumberingAction(e) {
    this.setState({ pwrelevantnumbering: e.target.value });
  }
  handleClick(cmd) {
    var newItems = this.state.repeatedItems;
    // The list is added to or removed from based on the user controls
    if (cmd === "inc" && newItems.length < this.props.maxRepeat) {
      newItems.push([].concat(this.props.children));
    } else if (cmd === "dec" && newItems.length > this.props.minRepeat) {
      newItems.splice(-1, 1);
    }

    // The list is updated and the UI re-rendered
    this.setState({
      repeatedItems: newItems,
      showBetween: true,
      selectTypeAll: true,
    });
  }

  showhide(i, e) {
    var show = this.state.className;
    show[i] = show[i] === "show" ? "hide" : "show";
    this.setState({ className: show });
  }

  addChar(e, i) {
    this["textInput" + i].value = this["textInput" + i].value + e;
    this["textInput" + i].focus();
  }

  render() {
    var titleRepeat = this.props.titleRepeat;
    var jae = this;
    var index = 0;

    // Since the children are an array of elements, loop through twice
    // This is brittle in handling children with nested elements
    //
    const felt = this.state.repeatedItems.map(function (itemGroup, i) {
      return (
        <Grid key={"grid" + i}>
          {i === 1 ? (
            <WhereToSearch
              pwrelevantnumberingAction={jae.pwrelevantnumberingAction}
              disableAnd={jae.disableAnd}
            />
          ) : null}{" "}
          {/* Denne vises bare hvis vi har to eller flere ord */}
          {i > 0 ? (
            <Panel key={"panel" + i + 1}>
              <Between
                wheretosearch={jae.state.wheretosearch}
                key={"pp" + i + 1}
                id={i + 1}
                show={jae.state.showBetween}
              />{" "}
            </Panel>
          ) : null}
          <Panel key={i + 1}>
            <Col md={12}>
              <Col md={6}>
                <h4>
                  {jae.props.mode === "multiple"
                    ? `${++index}.  ${titleRepeat}`
                    : titleRepeat}
                  {` `}
                  <small>
                    <span
                      className="wordsearch_showhide"
                      onClick={jae.showhide.bind(this, i)}
                    >{`show/hide advanced search options`}</span>
                  </small>
                </h4>
              </Col>
              <Col md={6}>
                <div className="specialSymbol">
                  <kbd onClick={jae.addChar.bind(jae, "\u0323", i)}>
                    {"\u0323"}
                  </kbd>{" "}
                  <kbd onClick={jae.addChar.bind(jae, "\u27E6", i)}>
                    {"\u27E6"}
                  </kbd>{" "}
                  <kbd onClick={jae.addChar.bind(jae, "\u27E7", i)}>
                    {"\u27E7"}
                  </kbd>{" "}
                  <kbd onClick={jae.addChar.bind(jae, "\u005B", i)}>
                    {"\u005B"}
                  </kbd>{" "}
                  <kbd onClick={jae.addChar.bind(jae, "\u2022", i)}>
                    {"\u2022"}
                  </kbd>{" "}
                  <kbd onClick={jae.addChar.bind(jae, "\u005D", i)}>
                    {"\u005D"}
                  </kbd>{" "}
                  <kbd onClick={jae.addChar.bind(jae, "\u002D", i)}>
                    {"\u002D"}
                  </kbd>{" "}
                </div>
              </Col>
            </Col>
            {itemGroup.map(function (item, j) {
              return jae.recursiveCloneChildren(item.props.children, i);
              //return React.cloneElement(item, {key:j+1, id: item.props.id + '-' + (i + 1)});
            })}
          </Panel>
        </Grid>
      );
    });
    return (
      <div>
        {felt}
        <Grid>
          <Col md={12}>
            <Col>
              <Button
                type="submit"
                onClick={this.props.onSubmit}
                className="btn btn-danger pull-left"
              >
                Search
              </Button>
            </Col>
            {this.state.repeatedItems.length < this.props.maxRepeat ? (
              <Col md={5}>
                <Button
                  type="button"
                  onClick={this.handleClick.bind(this, "inc")}
                  className="btn btn-default"
                >
                  Add word
                </Button>
              </Col>
            ) : null}
            {this.state.repeatedItems.length > this.props.minRepeat ? (
              <Col md={5}>
                <Button
                  type="button"
                  onClick={this.handleClick.bind(this, "dec")}
                  className="btn btn-default"
                >
                  Remove
                </Button>
              </Col>
            ) : null}
            <Col>
              <Button
                type="reset"
                onClick={this.props.onReset}
                className="btn btn-danger pull-right"
              >
                Reset
              </Button>
            </Col>
          </Col>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/Forms/WordSearchFormRepeatable.jsx